import { render, staticRenderFns } from "./ReqCompraReporteComponent.vue?vue&type=template&id=68488ed3&"
import script from "./ReqCompraReporteComponent.vue?vue&type=script&lang=js&"
export * from "./ReqCompraReporteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports